import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getModel } from './selectors';
import * as actions from './actions';
import GatewayEventsComponent from './GatewayEventsComponent';
import { withErrorBoundaryTrigger } from 'sharedComponents/ErrorBoundary';

const GatewayEventsContainer = (props) => {
    return <GatewayEventsComponent {...props} />;
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const GatewayEventsContainerWithErrorBoundaryTrigger = withErrorBoundaryTrigger(GatewayEventsContainer);

const GatewayEventsContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(GatewayEventsContainerWithErrorBoundaryTrigger);

export default GatewayEventsContainerConn;
